import { query, mutate } from '@/api/graphql';
import gql from 'graphql-tag';
import { always, mapObjIndexed, when } from 'ramda';
import isNullOrEmpty from '@/helpers/misc/isNullOrEmpty';
import { getLanguage } from '@/helpers/misc';
import GetSignatures from './graphql/queries/GetSignatures.graphql';
import GetAllSignatures from './graphql/queries/GetAllSignatures.graphql';
import GetSignature from './graphql/queries/GetSignature.graphql';
import SaveSignature from './graphql/mutations/SaveSignature.graphql';
import Signature from './graphql/fragments/signature.graphql';
import SignatureDetail from './graphql/fragments/signatureDetail.graphql';

export const getApprovedSignatures = async () => {
  const variables = {
    filter: {
      isApproved: true,
    },
    page: 1,
    limit: 999999,
  };

  const { signatures } = await query(gql`
    ${GetSignatures}
    ${Signature}
  `,
  variables);

  return signatures;
};

export const getAllSignatures = async () => {
  const language = getLanguage();

  const variables = {
    filter: { },
    page: 0,
    limit: 0,
    language,
  };

  const { signatures } = await query(gql`
      ${GetAllSignatures}
      ${Signature}
    `,
  variables);

  return signatures;
};

export const getSignatures = async (filter, page, limit) => {
  const language = localStorage.getItem('selectedLocale');
  const modifiedFilter = mapObjIndexed(when(isNullOrEmpty, always(undefined)), filter);

  const variables = {
    filter: { ...modifiedFilter },
    page,
    limit,
    language,
  };

  const { signatures } = await query(gql`
            ${GetAllSignatures}
            ${Signature}
    `,
  variables);

  return signatures;
};

export const getSignature = async id => {
  const variables = {
    id,
  };

  const { signature } = await query(gql`
      ${GetSignature}
      ${SignatureDetail}
  `,
  variables);

  return signature;
};

export const saveSignature = async input => {
  const variables = {
    input,
  };

  const result = await mutate(gql`
    ${SaveSignature}
  `,
  variables);

  return result;
};
